module.exports = {"70":27.4,"71":26.5,"72":25.6,"73":24.7,"74":23.8,"75":22.9,"76":22,"77":21.2,"78":20.3,"79":19.5,"80":18.7,"81":17.9,"82":17.1,"83":16.3,"84":15.5,"85":14.8,"86":14.1,"87":13.4,"88":12.7,"89":12,"90":11.4,"91":10.8,"92":10.2,"93":9.6,"94":9.1,"95":8.6}


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Retire/ira.json
// module id = 505
// module chunks = 0